
import { Grid, IconButton, Tooltip } from '@mui/material';
import './item-card.css';
import { useDispatch } from 'react-redux';
import * as componentActions from 'src/redux/actions/faqs';
import { Search } from '@mui/icons-material';
import { getDetailsById } from "src/services/faq.service";

const FaqCard = (props) => {
    const { faq, intl, history, lang, setLoading } = props

    const dispatch = useDispatch()

    const goToFaqEdit = async () => {
        if (faq && faq.id) {
            setLoading(true)
            const response = await getDetailsById(faq.id)
            if (response.success && response.data) {
                setLoading(false)
                dispatch(componentActions.addCurrent(response.data))
            }
            setLoading(false)
            history.push(`/${lang}/faq-edit`)
        }
    }

    const goToFaq = async () => {
        if (faq && faq.id) {
            localStorage.setItem("generalSearchFaqId", faq.id)
            window.open(`${window.location.origin}/${lang}/faq-external-client`, "_blank", "noopener,noreferrer")
        }
    }

    return (
        <Grid item container spacing={2} lg={12} md={12} sm={11} xs={11} className="cardItem" direction="row" alignItems="center" >
            <Grid item lg={2} md={2} sm={4} xs={4} style={{ display: "flex", alignItems: "center" }} onClick={goToFaqEdit}>
                <span className="boldLine-two" style={{ cursor: "pointer" }}>
                    ID {faq.id}
                </span>
            </Grid>
            <Grid item lg={1} md={2} sm={1} xs={1} className='moreActions'>
                <Tooltip title={<h5>{intl.formatMessage({ id: "read.faq" })}</h5>}>
                    <IconButton aria-label="table-popup" onClick={goToFaq} >
                        <Search />
                    </IconButton>
                </Tooltip>
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={6} style={{ display: "flex", alignItems: "center" }}>
                <span style={{ wordBreak: "break-word" }}>{faq.question}</span>
            </Grid>
            <Grid item lg={5} md={5} sm={6} xs={6} style={{ display: "flex", alignItems: "center" }}>
                <span style={{ wordBreak: "break-word" }}>{faq.answer}</span>
            </Grid>
        </Grid>
    )
}

export default FaqCard